import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export const RequireAuth = ({ children, allowedRoles }) => {
    const { user, isAuthenticated, isLoading, tenantStatus } = useAuth();
    const location = useLocation();

    // Wait until the account is matched to this tab's association (AuthContext),
    // so no portal query runs before the Super Admin tenant header is in place.
    if (isLoading || (isAuthenticated && tenantStatus !== 'ready')) {
        return (
            <div className="min-h-screen bg-main-bg flex items-center justify-center">
                <div className="bg-white rounded-2xl border border-amber-100/30 warm-tactile-shadow p-8">
                    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-secondary mx-auto" />
                    <p className="text-slate-500 mt-4 text-center text-sm font-bold">Loading...</p>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    if (allowedRoles && !allowedRoles.includes(user?.portalRole)) {
        return <Navigate to="/" replace />;
    }

    return children;
};
